import { Breadcrumbs } from 'AbstractElements';
import ReferrerListContain from 'Component/Learning/HistoryReferral/ReferrerList';

const UserHistoryReferralCompact = () => {
	return (
		<>
			<Breadcrumbs parent="Users" title="Daftar Referrer" />
			<ReferrerListContain />
		</>
	);
};
export default UserHistoryReferralCompact;